import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HOST,
})

export const cognitoAxiosInstance = (token, headers = {}) =>
  axios.create({
    baseURL: process.env.REACT_APP_BACKEND_HOST,
    headers: {
      Authorization: `Bearer ${token}`,
      'Device-Type': 'web',
      ...headers,
    },
  })

export default axiosInstance
